<template>
  <ValidationCard
    color="blue-grey lighten-3"
    :by="implementedBy"
    :date="implementedAt"
    :icon="icon"
    :title="$t('rev.status.rev_implemented')"
  >
    <template v-slot:actions v-if="!hasRequestValidation">
      <v-divider class="mx-6" />
      <v-card-actions class="d-flex justify-end px-6 py-3">
        <v-btn
          rounded
          data-testid="implement-button"
          data-tourid="implement-button"
          text
          color="primary"
          :disabled="!permissions.removeImplementation"
          @click="$emit('removeImplementation')"
          >{{ $t('rev.unmark_as_implemented_button') }}</v-btn
        >
      </v-card-actions>
    </template>
  </ValidationCard>
</template>

<script>
import { mapGetters } from 'vuex'

import { utils } from 'frontend-js-shared'

import revPermissionsMixin from '@/mixins/revPermissionsMixin'

import ValidationCard from './ValidationCard'

export default {
  name: 'ImplementCard',

  components: { ValidationCard },

  mixins: [revPermissionsMixin],

  props: ['rev', 'canImplement', 'hasRequestValidation'],

  data() {
    return {
      icon: {
        name: 'mdi-rocket-launch',
        color: 'blue-grey',
      },
    }
  },

  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),

    permissions() {
      return this.getPermissions({
        rev: this.rev,
        account: this.account,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },

    implementedBy() {
      return (
        this.rev?.validations?.implementation?.auditor ??
        this.rev?.validation?.implementationValidatedBy
      )
    },

    implementedAt() {
      const date =
        this.rev?.validations?.implementation?.validatedAt ??
        this.rev?.validation?.implementationValidatedAt
      return utils.dates.humanDate(date)
    },
  },
}
</script>
